const { createApp: createSnApp } = Vue;
createSnApp({
  data() {
    return {
      packages: [{month: 1, sachet: 20},{month: 3, sachet: 60},{month: 6, sachet: 120},{month: 12, sachet: 240}],
      er_20_message: '',
      er_60_message: '',
      er_120_message: '',
      er_240_message: '',
      is_20_sub: false,
      is_60_sub: false,
      is_120_sub: false,
      is_240_sub: false,
      product_20_id: null,
      product_60_id: null,
      product_120_id: null,
      product_240_id: null,
      product_objs: null,
      product_objs_sub: null,
      form: {
        product_id: null,
        variant_id: null,
        is_sub: false,
      },
      section_settings: null
    }
  },
  computed: {
    product_ids_list() { return `${this.product_20_id}_${this.product_60_id}_${this.product_120_id}_${this.product_240_id}` },
    variant_20() {
      if(this.is_20_sub) {
        return groupped_variants['20_sub'].find(v => v.product_id === this.product_20_id)
      }
      return groupped_variants['20'].find(v => v.product_id === this.product_20_id)
    },
    variant_60() {
      if(this.is_60_sub) {
        return groupped_variants['60_sub'].find(v => v.product_id === this.product_60_id)
      }
      return groupped_variants['60'].find(v => v.product_id === this.product_60_id)
    },
    variant_120() {
      if(this.is_120_sub) {
        return groupped_variants['120_sub'].find(v => v.product_id === this.product_120_id)
      }
      return groupped_variants['120'].find(v => v.product_id === this.product_120_id)
    },
    variant_240() {
      if(this.is_240_sub) {
        return groupped_variants['240_sub'].find(v => v.product_id === this.product_240_id)
      }
      return groupped_variants['240'].find(v => v.product_id === this.product_240_id)
    },
    product_20() { 
      if(this.variant_20) {
        if(this.is_20_sub) {
          return this.product_objs_sub.find(p => p.id === this.variant_20.product_id)
        }
        return this.product_objs.find(p => p.id === this.variant_20.product_id)
      }
      return null
    },
    product_60() { 
      if(this.variant_60) {
        if(this.is_60_sub) {
          return this.product_objs_sub.find(p => p.id === this.variant_60.product_id)
        }
        return this.product_objs.find(p => p.id === this.variant_60.product_id)
      }
      return null
    },
    product_120() { 
      if(this.variant_120) {
        if(this.is_120_sub) {
          return this.product_objs_sub.find(p => p.id === this.variant_120.product_id)
        }
        return this.product_objs.find(p => p.id === this.variant_120.product_id)
      }
      return null
    },
    product_240() { 
      if(this.variant_240) {
        if(this.is_240_sub) {
          return this.product_objs_sub.find(p => p.id === this.variant_240.product_id)
        }
        return this.product_objs.find(p => p.id === this.variant_240.product_id)
      }
      return null
    },
    product_20_title() { return this.product_20 ? this.product_20.title : '' },
    product_60_title() { return this.product_60 ? this.product_60.title : '' },
    product_120_title() { return this.product_120 ? this.product_120.title : '' },
    product_240_title() { return this.product_240 ? this.product_240.title : '' },
  },
  watch: {
    product_ids_list:{
      handler(val) {
        if(typeof exchangePrices === 'function') {
          exchangePrices()
        }
      },
      immediate: true,
    },
    /*is_20_sub:{
      handler(val) {
        console.log(`is_20_sub: ${val}`)
        console.log(`typeof is_20_sub: ${typeof val}`)
      },
      immediate: true,
    }*/
  },
  methods: {
    getError(sachet) { return this[`er_${sachet}_message`] },
    retrieveProduct(product_title) {
      product_title = product_title.toLowerCase();
      switch (true) {
        case product_title.includes('pineapple crush'):
          return "Pineapple Crush";
        case product_title.includes('perfectly peach'):
          return "Perfectly Peach";
        case product_title.includes('apple pie'):
          return "Apple Pie";
        case product_title.includes('berry fusion'):
          return "Berry Fusion";
        case product_title.includes('cherry surge'):
          return "Cherry Surge";
        case product_title.includes('strawberry lemonade'):
          return "Strawberry Lemonade";
        case product_title.includes('discovery pack'):
          return "Discovery Pack";
        case product_title.includes('better than - ashwagandha'):
        case product_title.includes('better than ashwagandha'):
          return "Ashwagandha";
        case product_title.includes('better than - glutathione'):
        case product_title.includes('better than glutathione'):
          return "Glutathione";
        case product_title.includes('better than - resveratrol'):
        case product_title.includes('better than resveratrol'):
          return "Resveratrol";
        case product_title.includes('cheat'):
          return "Cheat";
        case product_title.includes('lucid'):
          return "Lucid";
        case product_title.includes('pro'):
          return "Pro";
        case product_title.includes('shield'):
          return "Shield";
        case product_title.includes('sprint'):
          return "Sprint";
        case product_title.includes('zeus'):
          return "Zeus";
        default:
          return "Unknown";
      }
    },
    addToCart(sachet) {
      this[`er_${sachet}_message`] = ''
      let is_sub = this[`is_${sachet}_sub`]
      let variant_id = this.getVariant(sachet, 'id', is_sub)
      let formData = {'items': [{
        'id': variant_id,
        'quantity': 1
      }]}
      if(is_sub) {
        formData['attributes[_plan]'] = 1
        formData['properties[_plan]'] = 1
      }
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(r => {
        if(typeof r.items != 'undefined') {
          this.updateCart(r.items.map(l => {
            let line = {}
            line[l.id] = l.quantity
            return line
          }))
        }
        if(typeof r.message != 'undefined') {
          this[`er_${sachet}_message`] = r.message
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },
    updateCart(items) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      })
      .then(response => {
        return response.json();
      })
      .then(r => {
        if(typeof r.items != 'undefined') {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }))
          const cart_drawer = document.querySelector('.cart-drawer');
          if(cart_drawer) {
            cart_drawer.show();
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
    },
    getRadioValue(sachet) { return this[`is_${sachet}_sub`] },
    setRadioValue(val, sachet) {
      let current_title = this[`product_${sachet}_title`]
      let find_title = this.retrieveProduct(current_title)
      this[`is_${sachet}_sub`] = val
      let c_product
      if(val) {
        c_product = this.product_objs_sub.find(p => p.title.includes(find_title))
      }
      else {
        c_product = this.product_objs.find(p => p.title.includes(find_title))
      }
      if(c_product) {
        this[`product_${sachet}_id`] = c_product.id
      }
    },
    getProductSelected(sachet) {
      return this[`product_${sachet}_id`]
    },
    setProductSelected(product_id, sachet) {
      let is_sub = this[`is_${sachet}_sub`]
      if(is_sub) {
        this[`product_${sachet}_id`] = this.product_objs_sub.find(p => (''+p.id) == product_id)['id']
      }
      else {
        this[`product_${sachet}_id`] = this.product_objs.find(p => (''+p.id) == product_id)['id']
      }
    },
    getVariant(sachet, attribute, is_sub) {
      let current_title = this[`product_${sachet}_title`]
      let find_title = this.retrieveProduct(current_title)
      let c_product
      let c_variant
      let ret_value
      
      if(is_sub) {
        c_product = this.product_objs_sub.find(p => p.title.includes(find_title))
        if(c_product) {
          c_variant = groupped_variants[`${sachet}_sub`].find(v => v.product_id === c_product.id)
        }
      }
      else {
        c_product = this.product_objs.find(p => p.title.includes(find_title))
        if(c_product) {
          c_variant = groupped_variants[sachet].find(v => v.product_id === c_product.id)
        }
      }
      if(c_variant) {
        if(attribute == 'image') {
          let img_url = c_variant.featured_image || c_variant.image
          ret_value = img_url + ((img_url.indexOf('?') > -1) ? '&' : '?') + 'height=280'
        }
        else {
          ret_value = c_variant[attribute]
        }
      }
      return ret_value
    },
    findSelectedProduct() {
      let product_id = this.product_objs[0].id
      let is_sub = false
      if(document.referrer && (typeof document.referrer === 'string')) {
        let ref = new URL(document.referrer)
        let product_handle = (ref.pathname.split('noobru-')[1] || '')
        if(product_handle) {
          let find_title = this.retrieveProduct(product_handle.replaceAll('-', ' '))
          let f_product = this.product_objs.find(p => p.title.includes(find_title))
          if(f_product) {
            product_id = f_product.id
            is_sub = false
          }
          else {
            f_product = this.product_objs_sub.find(p => p.title.includes(find_title))
            if(f_product) {
              product_id = f_product.id
              is_sub = true
            }
          }
        }
      }
      this.is_20_sub = this.is_60_sub = this.is_120_sub = this.is_240_sub = is_sub
      this.product_20_id = this.product_60_id = this.product_120_id = this.product_240_id = product_id
    }
  },
  created() {
    this.section_settings = JSON.parse(JSON.stringify(section_settings))
    this.product_objs = JSON.parse(JSON.stringify(product_objs))
    this.product_objs_sub = JSON.parse(JSON.stringify(product_objs_sub))
    this.findSelectedProduct()
  },
}).mount('#app_shop_now');